// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@hardwoods/XDL/Utilities";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import React, { FC } from "react";
import styled from "styled-components";

const ProductSlideWrapper = styled.div<InjectableCss>`
    width: 100%;
    max-width: 305px;
    height: 100%;
    position: relative;
    padding: 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${color("common.border")};
    border-radius: 4px;
    background-color: ${color("text.inverse")};
    box-shadow: 0 0 8px 0 ${color("common.ui1", 0.2)};
    box-sizing: border-box;
    ${xScreen.lte("sm")} {
        margin: 0 auto;
    }

    ${injectCss}
`;

interface ProductCarouselSlideProps {
    [key: string]: any;
}

const ProductCarouselWrapper: FC<ProductCarouselSlideProps> = ({ children, ...otherProps }) => {
    return <ProductSlideWrapper {...otherProps}>{children}</ProductSlideWrapper>;
};

export default ProductCarouselWrapper;
